export default __webpack_public_path__ + "static/media/toyota.loader.d1700bff.gif";